import React from "react";
import Hero from "../components/Hero";
import Ticker from "../components/Ticker";
import TrendingTracks from "../components/TrendingTracks";
import FeaturedArtists from "../components/FeaturedArtists";
import NewsStories from "../components/NewsStories";
import GrowCareer from "../components/GrowCareer";
import WhyChoose from "../components/WhyChoose";
import FashionLifestyle from "../components/FashionLifestyle";
import Merch from "../components/Merch";
import SuccessStories from "../components/SuccessStories";
import Partners from "../components/Partners";
import Newsletter from "../components/Newsletter";

export default function Home() {
  return (
    <>
      <Hero />
      <Ticker />
      <TrendingTracks />
      <FeaturedArtists />
      <NewsStories />
      <GrowCareer />
      <WhyChoose />
      <FashionLifestyle />
      <Merch />
      <SuccessStories />
      <Partners />
      <Newsletter />
    </>
  );
}
